"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M474 673.4h89.7c14.4 0 26.1-9.8 26.1-21.9V376.8c.1-8.2 6.9-14.8 15.2-14.7h41.2c13.4 0 21.4-7.5 24.5-14.5 3.4-7.5 1.5-16.3-4.7-21.7L371.2 36.3c-10-9.8-29.6-9.8-39.5 0L36.8 326c-6.1 5.4-8 14.2-4.7 21.7 3.1 7 11.1 14.5 24.5 14.5h37c8.4 0 15.2 6.6 15.2 14.7v274.7c0 12.1 11.7 21.9 26 21.9h95.8V529c.1-8.2 6.9-14.8 15.2-14.7h212.9c8.4 0 15.2 6.6 15.2 14.7l.1 144.4zm89.7 29.4H458.8c-8.3.1-15.1-6.4-15.2-14.7V543.8H261.1v144.4c-.2 8.3-7 14.8-15.2 14.7h-111c-31.2 0-56.5-23-56.5-51.3v-260H56.6c-23.3 0-43.9-12.7-52.6-32.4-8-18.5-3.8-39.1 11.1-53.6L309.9 15.7c21.3-20.9 61.7-20.9 83 0l294.9 289.7c14.8 14.6 19.1 35.1 11 53.6-8.6 19.7-29.2 32.5-52.6 32.5h-25.9v260c0 28.3-25.4 51.3-56.6 51.3z"
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M478.9 659.6h80.3c10 0 18.1-6.4 18.1-14.3V376.2c.2-12.1 10.2-21.8 22.4-21.6H640c9.5 0 15.1-5 17.1-9.8 1.4-3.4 2.1-8.3-3.1-13.5L365.4 47.7c-7-6.9-21.1-6.9-28.1 0L48.8 331.5c-5.2 5.1-4.5 10.1-3 13.5 2 4.7 7.6 9.7 17.1 9.7h36.3c12.1-.2 22.1 9.4 22.3 21.6v269.1c0 7.9 8.1 14.3 18 14.3h86.3V525.4c.2-12.1 10.2-21.8 22.4-21.6h208.4c12.1-.2 22.1 9.4 22.3 21.6v134.2zm80.3 43.2H456.5c-12.1.2-22.1-9.4-22.3-21.6V547H270.5v134.2c-.2 12.1-10.2 21.8-22.3 21.6H139.5c-34.6 0-62.8-25.8-62.8-57.4V397.9H62.9c-25.8 0-48.8-14.2-58.3-36.2-9.1-20.8-4.4-44 12.4-60.3L305.5 17.5c23.6-23.3 68.2-23.3 91.9 0l288.5 283.8c16.7 16.4 21.5 39.5 12.4 60.3-9.5 22-32.5 36.2-58.3 36.2h-18v247.5c0 31.7-28.2 57.5-62.8 57.5z"
  })
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M687.7 305.4L392.9 15.7c-21.3-20.9-61.6-20.9-83 0L15.1 305.5C.2 320-4 340.6 4 359.1c8.6 19.7 29.2 32.4 52.5 32.4h21.8v260c0 28.3 25.3 51.3 56.5 51.3h111c8.2.2 15.1-6.4 15.2-14.6V543.8h182.5v144.4c.1 8.2 6.9 14.8 15.2 14.7h104.9c31.2 0 56.5-23 56.5-51.3v-260h26c23.3 0 44-12.7 52.5-32.4 8.2-18.6 4-39.2-10.9-53.8"
  })
});

var HomeDoor = function HomeDoor(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "HomeDoor-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-5 -5 710 710';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = HomeDoor;
exports["default"] = _default;

//# sourceMappingURL=index.js.map